// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { UnitOfMeasure } from "./UnitOfMeasure";
import {
  UnitOfMeasureFromJSON,
  UnitOfMeasureFromJSONTyped,
  UnitOfMeasureToJSON,
  UnitOfMeasureToJSONTyped,
} from "./UnitOfMeasure";

/**
 *
 * @export
 * @interface TableColumn
 */
export interface TableColumn {
  /**
   *
   */
  columnId: string;
  /**
   *
   */
  label?: string | null;
  /**
   *
   */
  unit?: UnitOfMeasure | null;
}

/**
 * Check if a given object implements the TableColumn interface.
 */
export function instanceOfTableColumn(value: object): value is TableColumn {
  if (
    (!("columnId" in (value as Record<string, any>)) &&
      !("column_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["columnId"] === undefined &&
      (value as Record<string, any>)["column_id"] === undefined)
  )
    return false;
  return true;
}

export function TableColumnFromJSON(json: any): TableColumn {
  return TableColumnFromJSONTyped(json, false);
}

export function TableColumnFromJSONTyped(json: any, ignoreDiscriminator: boolean): TableColumn {
  if (json == null) {
    return json;
  }
  return {
    columnId: json["column_id"],
    label: json["label"] === undefined ? undefined : json["label"] === null ? null : json["label"],
    unit:
      json["unit"] === undefined
        ? undefined
        : json["unit"] === null
        ? null
        : UnitOfMeasureFromJSON(json["unit"]),
  };
}

export function TableColumnToJSON(json: any): TableColumn {
  return TableColumnToJSONTyped(json, false);
}

export function TableColumnToJSONTyped(
  value?: TableColumn | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    column_id: value["columnId"],
    label: value["label"],
    unit: UnitOfMeasureToJSON(value["unit"]),
  };
}
